module.exports = __webpack_public_path__ + "static/media/master-card-payment-wv.ee3e0571.svg";